import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./css/index.css";

type Props = {
  isLogin: boolean;
  Logout: () => void;
};

function Header({ isLogin, Logout }: Props) {
  const navigate = useNavigate();
  return (
    <header>
      <Link to={"/"}>
        <img src="/assets/logo.svg" alt="" />
      </Link>
      {isLogin ? (
        <button
          onClick={() => {
            Logout();
            navigate("/");
          }}
        >
          로그아웃
        </button>
      ) : undefined}
    </header>
  );
}

export default Header;
